import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { memo } from 'react';
import { BalanceCard } from 'console/billing/balance-card';
import { Box } from '@mui/material';
import { H2000PlusFirmwareCard } from 'entities/billing.h2000-firmware/ui';
import { TariffStatus } from 'console/billing/account-tariff/status';
import { BuyThermostatForSocket03Card } from 'entities/billing.buy-socket-03-thermostat/ui';
export const BillingDialogContent = memo(function BillingDialogContent() {
    return (_jsxs(Box, { display: "flex", flexDirection: "column", gap: 2, p: 2, children: [_jsx(BalanceCard, { showIosBilling: true }), _jsx(TariffStatus, {}), _jsx(H2000PlusFirmwareCard, {}), _jsx(BuyThermostatForSocket03Card, {})] }));
});
